import { getEnvironment } from '../../environment'
import { addScript } from '../util'

function gtm_pageReady(icoDataLayer) {
  const environment = getEnvironment()
  const tagId = environment.gtmTagId
  window.google_tag_id = tagId

  try {
    if (addScript('www.googletagmanager.com/gtm.js?id=' + tagId)) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    }
  } catch (e) {
    console.log('gtm load error', e)
  }
}

export { gtm_pageReady }
